const $ = jQuery;
// Import additional libraries here
import '../../node_modules/lity/dist/lity';
import 'intersection-observer';
import Birds from './modules/bird-animation';
import Player from '@vimeo/player';



$(function(){
    if($('section').is('.birds-highway')){
        Birds.init();
    }
});

let isMobile = false;
$(window).on('load resize', function () {
    isMobile = window.matchMedia('(max-width : 767px)').matches;
    // console.log(isMobile);
});
$(document).ready(function() {

    // video

    $('.button').click(function () {
        $(this).children('.play').css({
            display: 'none'
        });


        const element = $(this).children('.hero-video')[0];
        let player = new Player(element);
        player.play();

        let src = player.element.src;
        let newSrc = src.slice(0, -1) + '1&autoplay=1';

        $(player.element).attr('src', newSrc);

        $(this).children('.hero-video').children('.blanket').css({
            display: 'none'
        });


    });


    // old code

    $("ul.sub-menu li > a").on("click touchend", function(e) {
        var el = $(this);
        var link = el.attr("href");
        window.location = link;
    });

//    CookiePro
    $(".footer-menu > ul > .menu-item").last( "li" ).first().after('<li class="menu-item"><a href="/#" onclick="return false;" id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Preferences</a></li>')

});
$(document).ready(function () {

    $('.navClick').click(function () {
        $(this).toggleClass('open');
        $('header.header').toggleClass('open');
    });

    $('.role').find('.role-header').click(function () {
        $('.role-header').not($(this)).removeClass('open').next('.role-content').slideUp(350);

        $(this).toggleClass('open');
        $(this).next('.role-content').slideToggle(350);
    });

    $('.faq').find('.faq-header').click(function () {
        $('.faq-header').not($(this)).removeClass('open').next('.faq-content').slideUp(350);

        $(this).toggleClass('open');
        $(this).next('.faq-content').slideToggle(350);
    });

    $('li.menu-item-has-children > a').click(function (e) {
        if (isMobile) {
            e.preventDefault();
            $(this).parent('li.menu-item-has-children').find('ul.sub-menu').slideToggle();
            $(this).parent('li.menu-item-has-children').toggleClass('open');
        }
    });
    // Variable declaration...
    let left, width, newLeft;

    // Add the "top-menu" class to the top level ul...
    $('.mobile-menu').children('ul').addClass('top-menu');

    // Add buttons to items that have submenus...
    $('.has_child_menu').append('<button class="arrow"><i class="fa fa-chevron-right"></i></button>');

    // Mobile menu toggle functionality
    $('.menu-toggle').on('click', function () {


        display = $('.mobile-menu').css("display");

        if (display === 'none') {

            // Display the menu...
            $('.mobile-menu').css("display", "block");
        } else {

            // Hide the mobile menu...
            $('.mobile-menu').css("display", "none");

            // and reset the mobile menu...
            $('.current-menu').removeClass('current-menu');
            $('.top-menu').css("left", "0");
            $('.back-button').css("display", "none");
        }
    });

    // Functionality to reveal the submenus...
    $('.arrow').on('click', function () {

        // The .current-menu will no longer be current, so remove that class...
        $('.current-menu').removeClass('current-menu');

        // Turn on the display property of the child menu
        $(this).siblings('ul').css("display", "block").addClass('current-menu');

        left = parseFloat($('.top-menu').css("left"));
        width = Math.round($('.mobile').width());
        newLeft = left - width;

        // Slide the new menu leftwards (into the .mobile viewport)...
        $('.top-menu').css("left", newLeft);

        // Also display the "back button" (if it is hidden)...
        if ($('.back-button').css("display") === "none") {
            $('.back-button').css("display", "flex");
        }
    });

    // Functionality to return to parent menus...
    $('.back-button').on('click', function () {

        // Hide the back button (if the current menu is the top menu)...
        if ($('.current-menu').parent().parent().hasClass('top-menu')) {
            $('.back-button').css("display", "none");
        }

        left = parseFloat($('.top-menu').css("left"));
        width = Math.round($('.mobile').width());
        newLeft = left + width;

        // Slide the new menu leftwards (into the .mobile viewport)...
        $('.top-menu').css("left", newLeft);

        // Allow 0.25 seconds for the css transition to finish...
        window.setTimeout(function () {

            // Hide the out-going .current-menu...
            $('.current-menu').css("display", "none");

            // Add the .current-menu to the new current menu...
            $('.current-menu').parent().parent().addClass('current-menu');

            // Remove the .current-menu class from the out-going submenu...
            $('.current-menu .current-menu').removeClass('current-menu');
        }, 250);
    });
});
$(document).ready(function () {
    $('.alpha1').on('click', function () {
        if($(this).hasClass('asc')) {
            let alphabeticallyOrderedDivs = $('.job.entry').sort(function (a, b) {
                return ($(a).find(".left").text() < $(b).find(".left").text() ? 1 : -1);
            });

            $(".jobs").html(alphabeticallyOrderedDivs);
            $(this).toggleClass('asc');
        } else {
            let alphabeticallyOrderedDivs = $('.job.entry').sort(function (a, b) {
                return ($(a).find(".left").text() > $(b).find(".left").text() ? 1 : -1);
            });

            $(".jobs").html(alphabeticallyOrderedDivs);
            $(this).toggleClass('asc');
        }
    });

    $('.alpha2').on('click', function () {
        if($(this).hasClass('asc')) {
            let alphabeticallyOrderedDivs = $('.job.entry').sort(function (a, b) {
                return ($(a).find(".middle").text() < $(b).find(".middle").text() ? 1 : -1);
            });

            $(".jobs").html(alphabeticallyOrderedDivs);
            $(this).toggleClass('asc');
        } else {
            let alphabeticallyOrderedDivs = $('.job.entry').sort(function (a, b) {
                return ($(a).find(".middle").text() > $(b).find(".middle").text() ? 1 : -1);
            });

            $(".jobs").html(alphabeticallyOrderedDivs);
            $(this).toggleClass('asc');
        }
    });

    $('.num1').on('click', function () {
        if($(this).hasClass('asc')) {
            let alphabeticallyOrderedDivs = $('.job.entry').sort(function (a, b) {
                return ($(a).find(".right .entry-time").attr('datetime') < $(b).find(".right .entry-time").attr('datetime') ? 1 : -1);
            });

            $(".jobs").html(alphabeticallyOrderedDivs);
            $(this).toggleClass('asc');
        } else {
            let alphabeticallyOrderedDivs = $('.job.entry').sort(function (a, b) {
                return ($(a).find(".right .entry-time").attr('datetime') > $(b).find(".right .entry-time").attr('datetime') ? 1 : -1);
            });

            $(".jobs").html(alphabeticallyOrderedDivs);
            $(this).toggleClass('asc');
        }
    });
})





// WEBPACK FOOTER //
// ./src/js/app.js